module.exports = __webpack_public_path__ + "static/111-67f1945e25098078c1151c5a52be1b31.png";